module.exports = __webpack_public_path__ + "img/5.0f4b83f8.jpg";